
import React from "react";
import { Box } from '@chakra-ui/react'



// type PFProjectsProps = {
//   children?: any;
// };



export const PFProjects = () => {
  return (
    <Box></Box>
    // <Box bg="fondo" d="flex" flexDirection="column" justifyContent="center" minW="100vw" m="0" p="0" py="64px" alignItems="center" >
    //   <Box>
    //     <PFHeading variant="h3" text="Portfolio section, show ppl stuff" color="primario" />
    //     <Box p="relative" px={["45px", "90px", "144px"]} d="flex" flexDir={"column"} gap="50px" justifyContent="space-around" mt="50px" alignItems={"center"}>
    //       <PFOverlay
    //         image={<PFImage stylesProps={{
    //           width: "545px",
    //           height: "534px",
    //           /**
    //            * how does this banner image have a hover effect, and how is the image inside the background work
    //            */
    //           //GOOGLE
    //           borderRadius: "20px"
    //         }} objectFit="cover" boxSize='100px' src="djnotlooking.jpg" />} heading={<PFHeading stylesProps={{ position: "absolute", bottom: "68px", left: "47px" }} color="blanco" variant="h3" text="A cool project"></PFHeading>}
    //         text={<PFParagraph variant="sub1" color="blanco" text="Something about that project" stylesProps={{ position: "absolute", bottom: "40px", left: "47px" }} />} />
    //       <PFOverlay
    //         image={<PFImage stylesProps={{
    //           width: "545px",
    //           height: "534px",
    //           /**
    //            * how does this banner image have a hover effect, and how is the image inside the background work
    //            */
    //           //GOOGLE
    //           borderRadius: "20px"
    //         }} objectFit="cover" boxSize='100px' src="carsmile.jpg" />} heading={<PFHeading stylesProps={{ position: "absolute", bottom: "68px", left: "47px" }} color="blanco" variant="h3" text="Cool project, numero dos"></PFHeading>}
    //         text={<PFParagraph variant="sub1" color="blanco" text="Maybe this can link to some other thing you did idk" stylesProps={{ position: "absolute", bottom: "40px", left: "47px" }} />} />
    //       <PFOverlay
    //         image={<PFImage stylesProps={{
    //           width: "545px",
    //           height: "534px",
    //           /**
    //            * how does this banner image have a hover effect, and how is the image inside the background work
    //            */
    //           //GOOGLE
    //           borderRadius: "20px"
    //         }} objectFit="cover" boxSize='100px' src="guitar.jpg" />} heading={<PFHeading stylesProps={{ position: "absolute", bottom: "68px", left: "47px" }} color="blanco" variant="h3" text="Some other cool thing"></PFHeading>}
    //         text={<PFParagraph variant="sub1" color="blanco" text="ran out of ideas for stuff to say" stylesProps={{ position: "absolute", bottom: "40px", left: "47px" }} />} />
    //       <PFButton variant="solid" size="size6" hover={{ bg: "linear-gradient(270deg, #1bd760 10.81%, #59EBFF 100%)" }}
    //       ><PFParagraph variant="boton" text="My Music" /></PFButton>
    //     </Box>
    //   </Box>
    // </Box >


  );
}
